export default __webpack_public_path__ + "static/GT-America-Standard-Medium-f1500b81278d06b127f93ed43f93d4c8.woff";